/** @format */

import React from 'react';
import './sample-pack.sass';
import withSamplePackHandler from './with_sample_pack_handler';
import SamplePackLogin from '../account/components/auth/ajax_login/sample_pack_login';
import {ConditionalButton} from 'frontier-utilities';
import {useInView} from 'react-intersection-observer';
import FormAddressInput from 'frontier/cart/components/addresses/form_address_input';
import {InputWithErrorHandler, Textarea, handleChange} from 'frontier-form';

export default withSamplePackHandler(
    handleChange(({formData, ...props}) => {
        const {ref, inView, entry} = useInView();
        if (props.isSubmissionSuccessful) {
            return (
                <div>
                    <h3 className="founder-sb">Submission successful!</h3>
                    <p style={{lineHeight: '24px'}}>
                        Our team is preparing your sample pack now and will send a confirmation
                        email once it mails out. If you have any questions in the meantime, please
                        give us a call or send us a chat. We are happy to help!
                    </p>
                </div>
            );
        }

        return (
            <div ref={ref}>
                {inView && (
                    <ConditionalButton enabled={!props.isLoggedIn}>
                        {!props.isLoggedIn && <SamplePackLogin onLogin={props.onLogin} />}
                        <div className="addresses">
                            <div className="bs4 bs4-form bs4-grid">
                                <div className="row">
                                    <div className="form-group tw-p-0">
                                        <FormAddressInput
                                            defaultCompany={formData.company}
                                            defaultAddress={formData.formatted_address}
                                            onUpdate={updateTarget => {
                                                props.onChangeBypass({formData: updateTarget});
                                            }}
                                            renderInputComponent={props => {
                                                return (
                                                    <InputWithErrorHandler
                                                        {...props}
                                                        newestds={true}
                                                        label={
                                                            props.inputProps?.name === 'company'
                                                                ? 'Company'
                                                                : 'Address'
                                                        }
                                                    />
                                                );
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="comments-container mt-4">
                                    <Textarea
                                        className="form-control form-control-sm sample-comments"
                                        value={props.comments}
                                        onChange={props.onInputChange.bind(
                                            this,
                                            'formData.comments'
                                        )}
                                        placeholder="Enter any special Sample Pack requests here..."
                                        maxLength={985}
                                    />
                                </div>
                            </div>
                            <div style={{marginTop: '20px'}}>
                                <ConditionalButton enabled={props.sending}>
                                    <button className="btn btn-primary" disabled>
                                        Submitting...
                                    </button>
                                    <button className="btn btn-primary" onClick={props.onSend}>
                                        Submit
                                    </button>
                                </ConditionalButton>
                            </div>
                        </div>
                    </ConditionalButton>
                )}
            </div>
        );
    })
);
